<template>
  <section class="forgot-page">
    <div class="forgot-container">
      <h1>Reset your password</h1>
      <p class="subtitle">
        Enter your email and we’ll send you a reset link.
      </p>

      <form @submit.prevent="handleSubmit" class="forgot-form">
        <div class="form-group">
          <label>Email</label>
          <input
            v-model="email"
            type="email"
            required
            placeholder="you@company.com"
          />
        </div>

        <button type="submit" :disabled="loading">
          {{ loading ? 'Sending...' : 'Send reset link' }}
        </button>
      </form>

      <p v-if="success" class="success">
        If an account exists, a reset link has been sent.
      </p>

      <p class="back">
        <router-link to="/sign-in">Back to sign in</router-link>
      </p>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue'
import * as api from '@/services/api.js'

const email = ref('')
const loading = ref(false)
const success = ref(false)

const handleSubmit = async () => {
  try {
    loading.value = true

    await api.auth.forgotPassword({ email: email.value })

    success.value = true
  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false
  }
}
</script>
<style scoped>
.forgot-page {
  min-height: 100vh;
  background: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.forgot-container {
  background: white;
  padding: 40px;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  text-align: center;
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 25px;
}

/* FORM */
.form-group {
  text-align: left;
  margin-bottom: 20px;
}

.form-group label {
  font-size: 0.9rem;
  color: #444;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

/* BUTTON */
button {
  width: 100%;
  padding: 12px;
  background: #0f172a;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* SUCCESS */
.success {
  margin-top: 20px;
  color: #16a34a;
  font-size: 0.9rem;
}

/* BACK */
.back {
  margin-top: 20px;
  font-size: 0.9rem;
}

.back a {
  color: #0f172a;
  text-decoration: none;
}

.back a:hover {
  text-decoration: underline;
}
</style>